"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CategoriesExpansionItem = exports.default = void 0;
const react_1 = __importStar(require("react"));
const ramda_1 = require("ramda");
const react_redux_1 = require("react-redux");
const expansion_item_1 = require("../expansion-item");
const store_1 = require("../../../store");
const CategoriesExpansionItem = ({ id, title, items, isOpen, onHeaderClick = () => { }, className, }) => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const includedCategoriesIds = (0, store_1.useProductsIncludedCategoriesIds)();
    const excludedCategoriesIds = (0, store_1.useProductsExcludedCategoriesIds)();
    const changeCategoriesIds = (0, react_1.useCallback)((selectedId, prevCategoriesIds) => {
        const selectedCategoriesIds = [selectedId];
        return (0, ramda_1.all)((selectedCategoryId) => prevCategoriesIds.includes(selectedCategoryId), selectedCategoriesIds)
            ? (0, ramda_1.without)(selectedCategoriesIds)
            : (0, ramda_1.concat)(selectedCategoriesIds);
    }, []);
    const handleCheckboxClick = (0, react_1.useCallback)((selectedId) => {
        const changeIncludedCategoriesIds = changeCategoriesIds(selectedId, includedCategoriesIds);
        (0, ramda_1.pipe)(changeIncludedCategoriesIds, ramda_1.uniq, store_1.productsSetIncludedCategoriesIds, dispatch)(includedCategoriesIds);
    }, [dispatch, includedCategoriesIds, changeCategoriesIds]);
    const handleBlockIconClick = (0, react_1.useCallback)((selectedId) => {
        const changeExcludedCategoriesIds = changeCategoriesIds(selectedId, excludedCategoriesIds);
        (0, ramda_1.pipe)(changeExcludedCategoriesIds, ramda_1.uniq, store_1.productsSetExcludedCategoriesIds, dispatch)(excludedCategoriesIds);
    }, [dispatch, excludedCategoriesIds, changeCategoriesIds]);
    return (react_1.default.createElement(expansion_item_1.ExpansionItem, { id: id, items: items, onHeaderClick: onHeaderClick, title: title, className: className, isOpen: isOpen, excludedSelectedIds: excludedCategoriesIds, includedSelectedIds: includedCategoriesIds, onBlockIconClick: handleBlockIconClick, onCheckboxClick: handleCheckboxClick }));
};
const MemoizedCategoriesExpansionItem = react_1.default.memo(CategoriesExpansionItem);
exports.default = MemoizedCategoriesExpansionItem;
exports.CategoriesExpansionItem = MemoizedCategoriesExpansionItem;
